import { Component, OnInit } from '@angular/core';
import { TranslationService, DictionaryProcessorService } from '@sdbn/common';
import commonDictionary from 'node_modules/@sdbn/common/assets/sdbn-common.dictionary.json';



@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  constructor(
    private translationService: TranslationService,
    private dictionaryProcessorService: DictionaryProcessorService 
  ) {

    console.log('processing dictionary', commonDictionary);
    this.translationService.addDictionaryEntries(dictionaryProcessorService.createDictionaryEntriesFromJSONTree(commonDictionary));

  }

  ngOnInit() {
  }


}
